export default __webpack_public_path__ + "static/media/group-187.6ee14286.png";